import http from "./http";

export default {
  potTipoMEta: form => http.post("/campanhas/tipo-meta", form),
  getTipoMeta: filter =>
    http.get("/campanhas/tipo-meta", { params: { ...filter } })
};
